/* @flow */

import { useLayoutEffect } from "react";

const useBrowserLayoutEffect: typeof useLayoutEffect = process.browser ? useLayoutEffect : () => {};

export default useBrowserLayoutEffect;
